import { useParams } from "react-router-dom";
import useNetworkThreatIntelAllReports from "../../hooks/useNetworkThreatIntelAllReports";
import { extractIPfromNetworkThreatReports } from "../../util";
import NetworkHeaderAnalysis from "./NetworkHeaderAnalysis";
import NetworkThreatHeaderClassification from "./NetworkThreatHeaderClassification";

const NetworkThreatSmallHeader = () => {
  const { url: _url = "", domain: _domain = "", ip: _ip = "" } = useParams();
  const { urlData, domainData, ipData } = useNetworkThreatIntelAllReports(
    _url,
    _domain,
    _ip
  );
  const ip =
    _ip ||
    extractIPfromNetworkThreatReports({
      ipReport: ipData.report,
      urlReport: urlData.report,
      domainReport: domainData.report
    });
  return (
    <div
      className={`network-threat-intel__main-header network-border network-border-${urlData.report?.classification} `}
    >
      <NetworkThreatHeaderClassification
        classification={urlData.report?.classification ?? "unknown"}
      />
      <NetworkHeaderAnalysis
        domain={domainData.report?.requested_domain}
        ip={ip}
        lastAnalysisDate={urlData.report?.analysis?.last_analysis.analysis_time}
      />
    </div>
  );
};

export default NetworkThreatSmallHeader;
